export enum TrackedTaskName {
  COMPRESS = "COMPRESS",
  DOWNLOAD = "DOWNLOAD",
  MERGE_PDF = "MERGE_PDF",
  PLOT_PDF = "PLOT_PDF",
  RASTERIZE_PDF = "RASTERIZE_PDF",
  SPLIT_PDF = "SPLIT_PDF",
  UPLOAD = "UPLOAD",
}
